import React, { useMemo } from "react";
import { Link } from "react-router-dom";

import { getLogoImgURLFromUserKind } from "../../lib/func/ExportFunction";
import ConstData from "../../lib/ConstData";    // 20261105 USE_LANDING_HTML 확인용
import { getLandingBaseUrl, LANDING_CACHE_KEY } from "../../lib/LandingPath";   // 20261105 디자이너 파일 경로

// 20261105 기본 도메인(hiclasstv)과 로컬 서버(local)는 디자이너 폴더의 로고를 공통 사용 (고객 서브도메인은 기존 서버 로고)
//          - 디자이너는 {landing}/images/header-logo.png 만 교체하면 됨 (빌드 불필요, 로컬 서버는 클라우드 파일 사용)
//          - 캐시 때문에 교체가 늦게 반영되지 않도록 앱을 열 때마다 새로 받도록 시간값을 붙임
//          - 파일이 없거나 읽지 못하면 기존 로고로 표시
const LANDING_LOGO_URL = getLandingBaseUrl() + "images/header-logo.png?t=" + LANDING_CACHE_KEY;
const LANDING_LOGO_USER_KINDS = ["hiclasstv", "local"];
const LANDING_TEST_LOGO_PATH_REGEX = /^[A-Za-z0-9_\-./]+$/;     // 20261105 header.js testLogo: landing 폴더 기준 상대경로

// 20261105 테스트/개발 서버(IS_DEV_VALUE)이고 header.js 의 testLogo 가 지정되어 있으면 테스트용 로고 주소 반환
//          (디자이너가 디자인을 마친 뒤 header-logo_test.png 를 만들어 testLogo 로 지정, 디자인 중에는 비워 둠)
const getLandingTestLogoUrl = () => {
    if (!ConstData.IS_DEV_VALUE) {
        return "";
    }

    const landingHeader = window.HICLASS_LANDING_HEADER;
    const testLogo = landingHeader && typeof landingHeader.testLogo === "string" ? landingHeader.testLogo.trim() : "";

    if (testLogo === "" || !LANDING_TEST_LOGO_PATH_REGEX.test(testLogo) || testLogo.indexOf("..") >= 0 || testLogo.charAt(0) === "/") {
        return "";
    }

    return getLandingBaseUrl() + testLogo + "?t=" + LANDING_CACHE_KEY;
};

const WebHeader = ({ userKind, isLoginYn, handleSelectedFunc }) => {

    const logoImgUrl = useMemo(() => getLogoImgURLFromUserKind(userKind), [userKind]);

    // 20261105 기본/로컬이면 디자이너 로고 우선
    const isLandingLogo = ConstData.USE_LANDING_HTML && LANDING_LOGO_USER_KINDS.indexOf(userKind) >= 0;

    // 20261105 테스트/개발 서버면 테스트용 로고 우선 (testLogo 지정 시)
    const landingTestLogoUrl = isLandingLogo ? getLandingTestLogoUrl() : "";

    // 20261105 로고를 읽지 못하면 다음 로고로 교체: 테스트용 로고 → 디자이너 로고 → 기존 로고
    const onErrorLogoImg = (e) => {
        if (!isLandingLogo) return;

        const currentSrc = e.currentTarget.getAttribute("src");

        if (landingTestLogoUrl !== "" && currentSrc === landingTestLogoUrl) {
            e.currentTarget.src = LANDING_LOGO_URL;
        } else if (currentSrc === LANDING_LOGO_URL) {
            e.currentTarget.src = logoImgUrl;
        }
    }

    const onClickHomeImg = () => {
        if (isLoginYn === "N") {
            handleSelectedFunc({ selectedFunc: "REFRESH_HOME" });
        }
    }

    return (
        <Link to="/main" style={{ textDecoration: 'none' }}>
            <img
                style={{ width: 'auto', height: '100%', maxHeight: '75px' }}
                src={isLandingLogo ? (landingTestLogoUrl !== "" ? landingTestLogoUrl : LANDING_LOGO_URL) : logoImgUrl}
                onError={onErrorLogoImg}
                onClick={onClickHomeImg}
                alt={userKind + "_logo"}
            />
        </Link>
    );
}

export default WebHeader;